import { useState } from 'react';

export const useGeocode = (lat: number, lng: number) => {
  const [center, setCenter] = useState({ lat, lng });

  const geocode = (location: string) => {
    const geocodeUrl = new URL(
      'https://maps.googleapis.com/maps/api/geocode/json'
    );
    geocodeUrl.searchParams.append('address', location);
    geocodeUrl.searchParams.append(
      'key',
      process.env.NX_GOOGLE_MAPS_API_KEY ?? ''
    );

    fetch(geocodeUrl)
      .then((response) => response.json())
      .then((data) => {
        const location = data.results[0].geometry.location;

        if (location) {
          setCenter(location);
        }
      })
      .catch((error) => console.error(error));
  };


  return { center, geocode };
};
